import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { isGenericPortal } from "../utils/subdomain";

/**
 * Restricts routes to generic company portal hosts (beta / company-dev / company-stg).
 * Tenant subdomains (e.g. amazon.beta.criticalasset.com) are redirected to login.
 */
export const PortalOnlyRoute = ({ children }: { children: JSX.Element }) => {
  if (!isGenericPortal()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};
